var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.916 42.008c-8.522 0-15.753-6.39-16.91-14.732h19.27V8.005c8.343 1.158 14.732 8.388 14.732 16.91 0 9.426-7.667 17.093-17.092 17.093m1.441-36.096l-1.066-.08v19.46H5.832l.08 1.066c.742 9.888 9.09 17.634 19.004 17.634 10.52 0 19.076-8.557 19.076-19.076 0-9.915-7.746-18.262-17.635-19.004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.655 20.655H17.09V7.007a17.086 17.086 0 0 1 3.565-.904v14.552zM9.556 12.502v8.153H6.102a17.084 17.084 0 0 1 3.454-8.153zm1.986-2.139a16.993 16.993 0 0 1 3.563-2.484v12.776h-3.564V10.363zM22.64 3.93l-1.067.08a19.049 19.049 0 0 0-12.14 5.61A19.069 19.069 0 0 0 4.01 21.572l-.08 1.066h18.71V3.93z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.82d5900f75bfc245a3cb406590606b5d.svg";
export { ForwardRef as ReactComponent };